<div class="mode-toggle" role="group" [attr.aria-label]="'map.mode.groupLabel' | translate" data-testid="map-mode-toggle">
  <button
    type="button"
    class="mode-toggle-btn"
    [class.active]="mapModeService.mode() === 'interaction'"
    [attr.aria-pressed]="mapModeService.mode() === 'interaction'"
    [tippy]="'map.mode.interaction.tooltip' | translate"
    [attr.aria-label]="'map.mode.interaction.tooltip' | translate"
    (click)="setMode('interaction')"
    data-testid="map-mode-interaction"
  >
    <app-icon name="pencil" [size]="16" />
    <span class="mode-toggle-label">{{ 'map.mode.interaction.label' | translate }}</span>
  </button>
  <button
    type="button"
    class="mode-toggle-btn"
    [class.active]="mapModeService.mode() === 'browse'"
    [attr.aria-pressed]="mapModeService.mode() === 'browse'"
    [tippy]="'map.mode.browse.tooltip' | translate"
    [attr.aria-label]="'map.mode.browse.tooltip' | translate"
    (click)="setMode('browse')"
    data-testid="map-mode-browse"
  >
    <app-icon name="eye" [size]="16" />
    <span class="mode-toggle-label">{{ 'map.mode.browse.label' | translate }}</span>
  </button>
</div>
